import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import MainLayout from 'src/layouts/MainLayout';
import Loading from 'src/components/Loading';
import {
  loadAvalQuoteInfo,
  clearAvalToken,
  LOAD_AVAL_QUOTE_INFO
} from 'src/store/actions/avalBuroFormActions';
import { selectAvalTokenValidationStatus } from 'src/store/selectors/avalBuroFormSelectors';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import AvalBuroForm from './AvalBuroForm';

const AvalBuroFormView = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { avalToken } = useParams();

  const tokenValidationStatus = useSelector(selectAvalTokenValidationStatus);
  const isLoading = useSelector(isLoadingSelector([LOAD_AVAL_QUOTE_INFO.action]));

  useEffect(() => {
    dispatch(loadAvalQuoteInfo(avalToken));
    return () => {
      dispatch(clearAvalToken());
    };
  }, [avalToken]);

  if (isLoading || tokenValidationStatus === 'pending') {
    return (
      <MainLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', flexDirection: 'column' }}>
          <Loading />
          <Typography variant="body1" sx={{ marginTop: 2 }}>
            {t('COMMON.LOADING')}
          </Typography>
        </Box>
      </MainLayout>
    );
  }

  if (tokenValidationStatus === '403') {
    return (
      <MainLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', flexDirection: 'column' }}>
          <Typography variant="h6" color="error">
            {t('AVAL_BURO_FORM.ERRORS.QUOTE_CONVERTED')}
          </Typography>
        </Box>
      </MainLayout>
    );
  }

  if (tokenValidationStatus === '401' || (tokenValidationStatus && tokenValidationStatus !== 'success')) {
    return (
      <MainLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', flexDirection: 'column' }}>
          <Typography variant="h6" color="error">
            {t('AVAL_BURO_FORM.ERRORS.INVALID_TOKEN')}
          </Typography>
        </Box>
      </MainLayout>
    );
  }

  if (tokenValidationStatus !== 'success') return null;

  return (
    <MainLayout>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: { xs: '12px', sm: '20px', md: '32px' },
          flexDirection: 'column',
          minHeight: '100dvh'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: { xs: '20px', sm: '32px', md: '40px' },
            textAlign: 'center'
          }}
        >
          <Typography
            variant="h1"
            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }}
          >
            {t('AVAL_BURO_FORM.TITLE')}
          </Typography>
        </Box>
        <AvalBuroForm />
      </Box>
    </MainLayout>
  );
};

export default AvalBuroFormView;
